import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DoctorSocialService } from '../doctor-social.service';
import { AppService } from 'src/app/app.service';
import { ToastrService } from 'ngx-toastr';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-edit-post-dialog',
  templateUrl: './edit-post-dialog.component.html',
  styleUrls: ['./edit-post-dialog.component.css']
})
export class EditPostDialogComponent implements OnInit {

  form: FormGroup;
  initPostText

  postDetails;

  constructor(
    public dialogRef: MatDialogRef<EditPostDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private service: DoctorSocialService,
    public app: AppService,
    private toaster: ToastrService,
  ) { }

  ngOnInit(): void {
    this.form = new FormGroup({
      PostText: new FormControl(""),
    });
    this.getPostById();
  }
  
  get = (formControlName: string) => this.form.get(formControlName) as FormControl;
  
  getPostById() {
    this.service.getPostById(this?.data).subscribe(
      res => {
        if (res.errorCode == 0) {
          this.postDetails = res.data
          this.get("PostText").setValue(res?.data?.postText)
          this.initPostText = res?.data?.postText
        } else if (res.errorCode != 0) {
          if (res.data.data.length == 0) {
            if (this?.app?.getUserLanguage() == 'en') {
              this.toaster.error("Something went wrong");
            } else if (this?.app?.getUserLanguage() == 'ar') {
              this.toaster.error("حدث خطأ ما");
            }
          }
        }
      }
    )

  }

  cancel(): void {
    this.dialogRef.close(null);
  }

  checkValidityForm = (): Promise<Boolean> => {
    // Check Form Validity 
    if (this.form.invalid) {
      if (this?.app?.getUserLanguage() == 'en') {
        this.toaster.error("Please Fill out all required inputs.");
      } else if (this?.app?.getUserLanguage() == 'ar') {
        this.toaster.error("يرجى ملء جميع المدخلات المطلوبة.");
      }
      this.form.markAllAsTouched();
      return Promise.resolve(false);
    }
    return Promise.resolve(true) as Promise<Boolean>;
  }

  getRequestPayLoad = (): FormData => {
    let request = new FormData();
    request.append("PostText", this.get("PostText").value);
    return request;
  }

  submit = async (): Promise<void> => {
    this.app.showLoading();
    await this.checkValidityForm() && this.service.patchFeed(this?.data, await this.getRequestPayLoad()).subscribe((res: any) => {
      if (res.errorCode == 0) {
        if (this?.app?.getUserLanguage() == 'en') {
          this.toaster.success("Updated Successfully");
        } else if (this?.app?.getUserLanguage() == 'ar') {
          this.toaster.success("تم التعديل بنجاح");
        }
        this.dialogRef.close("edit");
      }
      if (res.errorCode != 0) {
        if (this?.app?.getUserLanguage() == 'en') {
          this.toaster.error("Something went wrong");
        } else if (this?.app?.getUserLanguage() == 'ar') {
          this.toaster.error("حدث خطأ ما");
        }
      }
    })
    this.app.dismissLoading();
  }

}
